'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class; // Lib


// Decorators


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _debugManagerDecorator = require('../debug/debugManagerDecorator');

var _debugManagerDecorator2 = _interopRequireDefault(_debugManagerDecorator);

var _BrowserDetection = require('../components/error/browserSupport/BrowserDetection');

var _BrowserDetection2 = _interopRequireDefault(_BrowserDetection);

var _DebugToolbarContainer = require('../debug/DebugToolbarContainer');

var _DebugToolbarContainer2 = _interopRequireDefault(_DebugToolbarContainer);

require('./AppInit.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppInitContainer = (0, _debugManagerDecorator2.default)(_class = function (_React$Component) {
    _inherits(AppInitContainer, _React$Component);

    function AppInitContainer() {
        _classCallCheck(this, AppInitContainer);

        return _possibleConstructorReturn(this, (AppInitContainer.__proto__ || Object.getPrototypeOf(AppInitContainer)).apply(this, arguments));
    }

    _createClass(AppInitContainer, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'App' },
                this.props.children,
                _react2.default.createElement(_BrowserDetection2.default, this.props),
                _react2.default.createElement(_DebugToolbarContainer2.default, this.props)
            );
        }
    }]);

    return AppInitContainer;
}(_react2.default.Component)) || _class;

AppInitContainer.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

exports.default = AppInitContainer;


//////////////////
// WEBPACK FOOTER
// ./src/client/app/AppInitContainer.js
// module id = 1666
// module chunks = 0